import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import { CartProvider } from "./lib/cart.tsx";
import { ProductsProvider } from "./lib/products-context.tsx";
import { initVariant } from "./lib/variant.ts";
import "./index.css";

initVariant();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <ProductsProvider>
          <CartProvider>
            <App />
          </CartProvider>
        </ProductsProvider>
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>,
);
